import { Flex, IconButton, Tooltip, useDisclosure } from '@chakra-ui/react';
import { RejectModal } from './changeStateModals/RejectModal';
import { AcceptModal } from './changeStateModals/AcceptModal';
import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';
import { RevertToPendingModal } from './changeStateModals/RevertToPendingModal';
import { Icons } from '@texas/components/shared/Icons';
import { usePublisher } from '@texas/messageBus/useMessageBus';
import { productApprovalEvents } from '@texas/components/shared/productApproval/events';
import { useTranslation } from 'react-i18next';
import { CancelModal } from './changeStateModals/CancelModal';
import { ConfigureCompositionGroupGarp } from '@texas/messageBus/messages';

export function PaMenu({
  id,
  state,
  branchId,
  variantId,
  linkedVariantId,
  isMatrix,
  compositionGroupId,
  onChanged,
}: {
  id: number;
  state: ProductApprovalState;
  branchId: number;
  variantId: number;
  linkedVariantId: number | null;
  isMatrix: boolean;
  compositionGroupId: number;
  onChanged: (id?: number) => void;
}) {
  const { publish } = usePublisher();
  const {
    isOpen: isRejectOpen,
    onClose: onRejectClose,
    onOpen: onRejectOpen,
  } = useDisclosure();
  const {
    isOpen: isAcceptOpen,
    onClose: onAcceptClose,
    onOpen: onAcceptOpen,
  } = useDisclosure();
  const { t } = useTranslation();

  return (
    <Flex gap={1}>
      {state === ProductApprovalState.Accepted && !isMatrix && linkedVariantId && (
        <Tooltip label={t('garp.fillData')}>
          <IconButton
            variant="texas-light"
            onClick={() =>
              publish(
                new ConfigureCompositionGroupGarp(
                  compositionGroupId,
                  linkedVariantId,
                  branchId,
                  id,
                ),
              )
            }
            size="sm"
            icon={<Icons.BriefcaseArrowLeftRight boxSize="4" />}
            aria-label={t('garp.fillData')}
          />
        </Tooltip>
      )}

      {state !== ProductApprovalState.Rejected && (
        <Tooltip label={t('productApproval.rejectPaTooltip')}>
          <IconButton
            variant="texas-light"
            onClick={onRejectOpen}
            size="sm"
            icon={<Icons.Cancel boxSize="4" />}
            aria-label={t('productApproval.rejectPaTooltip')}
          />
        </Tooltip>
      )}
      {state !== ProductApprovalState.Accepted && (
        <Tooltip label={t('productApproval.acceptTooltip')}>
          <IconButton
            variant="texas-light"
            onClick={onAcceptOpen}
            size="sm"
            icon={<Icons.Checkmark boxSize="4" />}
            aria-label={t('productApproval.acceptTooltip')}
          />
        </Tooltip>
      )}
      {state !== ProductApprovalState.Cancelled && (
        <CancelModal productApprovalId={id} onCancel={() => onChanged(id)} />
      )}
      {state !== ProductApprovalState.Pending && (
        <RevertToPendingModal
          productApprovalId={id}
          onRevert={() => onChanged(id)}
        />
      )}
      <RejectModal
        isOpen={isRejectOpen}
        onClose={onRejectClose}
        productApprovalId={id}
        onReject={() => {
          onChanged(id);
          productApprovalEvents.productApprovalRejected.dispatch();
        }}
      />
      <AcceptModal
        productApprovalId={id}
        branchId={branchId}
        variantId={variantId}
        onClose={onAcceptClose}
        isOpen={isAcceptOpen}
        onAccept={() => {
          onChanged(id);
          if (isMatrix) return;

          productApprovalEvents.productApprovalAccepted.dispatch();
        }}
      />
    </Flex>
  );
}
